import styles from './FormItem.module.css';

interface FormItemProps {
  children?: React.ReactNode;
}

const FormItem = ({ children }: FormItemProps): JSX.Element => {
  return <div className={styles.formItem}>{children}</div>;
};

export default FormItem;
